@if(isRequired){
<div>
  <mat-form-field class="w-100pr">
    <input matInput #stateAutoComplete placeholder="State" [formControl]="selectedStateFormControl"
      (input)="onInputChangedState($event.target.value)" [matAutocomplete]="autocompleteState" required>
    <mat-autocomplete #autocompleteState="matAutocomplete" [displayWith]="displayFnAutoCompleteState">
      @for(item of stateAutoCompleteList; track item){
      <mat-option (onSelectionChange)="onChangeState($event)" [value]="item">
        {{ item.text }}
      </mat-option>
      }
    </mat-autocomplete>
    @if(selectedStateFormControl.hasError('required')){
    <mat-error>
      State is required
    </mat-error>
    }
  </mat-form-field>
</div>
}

@if(!isRequired){
<div>
  <mat-form-field class="w-100pr">
    <input matInput #stateAutoComplete placeholder="State" [formControl]="selectedStateFormControl"
      (input)="onInputChangedState($event.target.value)" [matAutocomplete]="autocompleteState">
    <mat-autocomplete #autocompleteState="matAutocomplete" [displayWith]="displayFnAutoCompleteState">
      @for(item of stateAutoCompleteList; track item){
      <mat-option (onSelectionChange)="onChangeState($event)" [value]="item">
        {{ item.text }}
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
}